"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "m2.366 12.96 7.955 8.642c.488.53 1.28.53 1.768 0s.488-1.39 0-1.92l-5.821-6.324H20.75c.69 0 1.25-.608 1.25-1.358 0-.75-.56-1.358-1.25-1.358H6.268l5.82-6.324a1.44 1.44 0 0 0 0-1.92 1.18 1.18 0 0 0-1.767 0L2.366 11.04a1.442 1.442 0 0 0 0 1.92Z"
  })]
});